// extracted by mini-css-extract-plugin
export var billingterm = "wptable-module--billingterm--651cc";
export var planName = "wptable-module--plan-name--1c8d4";
export var price = "wptable-module--price--8284f";
export var wptable = "wptable-module--wptable--e73eb";